import { render, staticRenderFns } from "./AttachmentModal.vue?vue&type=template&id=78630a7a&scoped=true&"
import script from "./AttachmentModal.vue?vue&type=script&lang=js&"
export * from "./AttachmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentModal.vue?vue&type=style&index=0&id=78630a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78630a7a",
  null
  
)

export default component.exports